module.exports = __webpack_public_path__ + "media/images/flags/64/Antigua-and-Barbuda-54fdd51812599c068c184e51e156b00a.png";